import styled from 'styled-components/macro';
export const RIconsWrapper = styled.div`
  display: flex;
  z-index: 100;
  margin-left: 0.9rem;
`;
